import React from "react";
import { useLocation } from "react-router-dom";
import recognition from "@/assets/brand/dyness-global-recognition-2026.webp";

/** Dyness global recognition strip under the header. The home page shows it inside the hero instead. */
export const RecognitionBanner = () => {
  const { pathname } = useLocation();
  if (pathname === "/") return null;

  return (
    <section className="w-full bg-ei-navy" data-testid="recognition-banner">
      <div className="mx-auto w-full max-w-[1800px] px-2 py-2 sm:px-4">
        <img
          src={recognition}
          alt="Dyness global recognition — EUPD Research Top Brand PV Storage awards across Brazil, Czech Republic, South Africa, Romania, Poland, Germany, Mexico, LATAM, Africa, Kenya and the United Kingdom, 2022 to 2026"
          className="mx-auto h-auto max-h-[110px] w-full max-w-none object-contain sm:max-h-[160px]"
          loading="eager"
          data-testid="recognition-banner-image"
        />
      </div>
    </section>
  );
};
